import { AnimatePresence, motion } from "framer-motion";
import { DotLottiePlayer } from "@dotlottie/react-player";
import "@dotlottie/react-player/dist/index.css";

import "./styles.css";

import Avatar from "../../../assets/images/avatar.png";
import { useEffect, useState } from "react";
import { useLanguage } from "../../../i18n/LanguageContext";

const iconList = [
  "🧑🏻‍💻️",
  "🎨",
  "🎮",
  "👩🏻‍❤️‍👨🏻",
  "💪🏻",
  "☕️",
  "🐶🐱",
  "🎻",
  "🎧",
  "🤓",
];
const MeSection = () => {
  const { t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % iconList.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ 
          duration: 0.8, 
          ease: [0.22, 1, 0.36, 1],
          staggerChildren: 0.1
        }}
        className="font-bold text-4xl mt-6 overflow-hidden"
      >
        <motion.span
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="inline-block"
        >
          {t.hero.greeting}&nbsp;
        </motion.span>
        <motion.span
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="inline-block"
        >
          Azat&nbsp;
        </motion.span>
        <motion.span
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="inline-block"
        >
          ESER
        </motion.span>
      </motion.h1>

      <p className="sr-only">{t.hero.srIntro}</p>


      <div className="mt-8 z-10">
        <motion.div 
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ 
            duration: 0.8, 
            delay: 0.3, 
            ease: [0.22, 1, 0.36, 1] 
          }}
          whileHover={{ scale: 1.05 }}
          className="w-40 h-40 relative group"
        >
          <img
            className="w-full h-full object-cover group-hover:scale-110 transition-all duration-1000"
            src={Avatar}
            alt="Azat ESER Avatar"
          />
          <div className="shine group-hover:w-[8.5rem] group-hover:h-[8.5rem] transition-all"></div>
          <div className="absolute w-24 h-24 top-8 left-8 animate-ping group-hover:animate-none bg-[#312645] rounded-full -z-10"></div>
          <div className="absolute w-32 h-32 top-4 left-4 animate-avatar bg-[#312645] rounded-full -z-10"></div>
          <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center h-8">
            <motion.div 
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6, delay: 0.7, ease: "easeInOut" }}
              className="text-4xl"
            >
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentIndex}
                  initial={{ opacity: 0, y: 20, scale: 0.8 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -20, scale: 0.8 }}
                  transition={{ 
                    duration: 0.5, 
                    ease: [0.22, 1, 0.36, 1]
                  }}
                  className="flex items-center justify-center"
                  style={{
                    userSelect: "none",
                  }}
                >
                  {iconList[currentIndex]}
                </motion.div>
              </AnimatePresence>
            </motion.div>
          </div>
        </motion.div>
      </div>
      <div className="relative w-full h-[500px] flex flex-col items-center">
        <h2
          className="flex flex-col lg:text-8xl md:text-7xl transition-all text-6xl w-max text-white font-inter z-10 select-none font-black text-center mt-16 mix-blend-overlay opacity-80"
          style={{ textShadow: "0px 0px 0px #ddd7b0" }}
        >
          <motion.span 
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ 
              duration: 0.8, 
              delay: 0.7, 
              ease: [0.22, 1, 0.36, 1] 
            }}
          >
            {t.hero.role[0]}
          </motion.span>
          <motion.span 
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ 
              duration: 0.8, 
              delay: 0.9, 
              ease: [0.22, 1, 0.36, 1] 
            }}
          >
            {t.hero.role[1]}
          </motion.span>
        </h2>

        <div
          style={{
            backgroundColor: "rgb(18, 17, 32)",
            height: "100%",
            width: "100%",
            opacity: 1,
            overflow: "hidden",
            position: "absolute",
            zIndex: -999,
            left: 0,
            bottom: 0,
          }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, delay: 0.5 }}
            style={{
              opacity: 1,
              height: "349px",
              left: "calc(50.069444444444464% - 1254px / 2)",
              overflow: "visible",
              position: "absolute",
              top: "calc(49.83660130718957% - 349px / 2)",
              width: "1254px",
            }}
          >
            <motion.div
              animate={{ 
                scale: [1, 1.05, 1],
                opacity: [0.9, 0.95, 0.9]
              }}
              transition={{ 
                duration: 8, 
                repeat: Infinity,
                repeatType: "reverse"
              }}
              style={{
                background:
                  "radial-gradient(50% 50% at 50% 50%, hsl(263, 82%, 35%) 0%, rgba(87, 57, 53, 0) 100%)",
                filter: "blur(64px)",
                WebkitFilter: "blur(64px)",
                opacity: "0.9",
                bottom: 0,
                flex: "none",
                left: 0,
                overflow: "visible",
                position: "absolute",
                top: 0,
                width: "838px",
                height: "349px",
              }}
            />
            <motion.div
              animate={{ 
                scale: [1, 1.05, 1],
                opacity: [0.95, 0.9, 0.95]
              }}
              transition={{ 
                duration: 7, 
                repeat: Infinity,
                repeatType: "reverse",
                delay: 1
              }}
              style={{
                background:
                  "radial-gradient(50% 50% at 50% 50%, hsl(11, 32%, 44%) 0%, rgba(87, 57, 53, 0) 100%)",
                filter: "blur(64px)",
                WebkitFilter: "blur(64px)",
                opacity: "0.95",
                bottom: 0,
                flex: "none",
                overflow: "visible",
                position: "absolute",
                right: 0,
                top: 0,
                width: "864px",
                height: "349px",
              }}
            />
            <motion.div
              animate={{ 
                scale: [1, 1.1, 1],
                opacity: [0.7, 0.8, 0.7]
              }}
              transition={{ 
                duration: 6, 
                repeat: Infinity,
                repeatType: "reverse",
                delay: 2
              }}
              style={{
                background:
                  "radial-gradient(50% 50% at 50% 50%, hsl(243, 50%, 48%) 0%, rgba(87, 57, 53, 0) 100%)",
                filter: "blur(64px)",
                WebkitFilter: "blur(64px)",
                opacity: "0.7",
                flex: "none",
                height: "295px",
                left: "calc(49.9202551834131% - 324px / 2)",
                overflow: "visible",
                position: "absolute",
                top: "calc(49.85673352435532% - 295px / 2)",
                width: "324px",
              }}
            />
          </motion.div>
        </div>
      </div>
        {/* Value proposition + calls to action, above the oversized backdrop type */}
        <div className="hero-cta relative z-20 flex w-full flex-col items-center px-6 -mt-[150px] md:-mt-[110px]">
          <p className="max-w-xl text-center text-base md:text-lg text-[rgba(245,245,245,0.72)] font-light leading-relaxed">
            {t.hero.intro}
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#work"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById("work");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              className="group inline-flex items-center gap-2 rounded-lg bg-[rgb(116,56,255)] px-6 py-3.5 text-sm font-semibold text-white shadow-lg transition-all duration-300 hover:bg-[rgb(132,79,255)] hover:shadow-[0_0_30px_-4px_rgba(116,56,255,0.7)]"
            >
              {t.hero.ctaWork}
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
            <a
              href="mailto:azatesser@gmail.com"
              className="inline-flex items-center gap-2 rounded-lg border border-[rgba(255,255,255,0.16)] bg-[rgba(255,255,255,0.04)] px-6 py-3.5 text-sm font-semibold text-[rgba(245,245,245,0.85)] backdrop-blur-sm transition-all duration-300 hover:border-[rgba(255,255,255,0.32)] hover:bg-[rgba(255,255,255,0.08)] hover:text-white"
            >
              {t.hero.ctaContact}
            </a>
          </div>


        </div>

      <DotLottiePlayer
        src="https://framerusercontent.com/modules/assets/6Hwubvigct3R3CXW9AZ1cvnVgrs~HSi6JbhLs8FDE1I8AFixXTRDU41ZWt4z5-iz0-4-2gM.zip"
        autoplay
        loop
        background="rgba(0, 85, 255, 0)"
        speed="1"
        direction="1"
        style={{
          width: "100%",
          height: "100%",
          opacity: 0.1,
          transform: "perspective(1200px)",
          position: "absolute",
          bottom: -280,
          left: 0,
          zIndex: 0,
        }}
      />
    </div>
  );
};

export default MeSection;
